import {z} from "zod";

export const referralCodeSchema = z.object({
  code: z
    .string()
    .trim()
    .toLowerCase()
    .min(3, "El código debe tener al menos 3 caracteres")
    .max(64, "El código es demasiado largo"),
});

export type ReferralCodeFormValues = z.infer<typeof referralCodeSchema>;
